import {Component, OnChanges} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'camiones-tco';

  constructor(private _route: Router) {
  }


  get route(): Router {
    return this._route;
  }

  onActivate(): void {
    let backgroundColor = '#FFF';
    if (['/calculadora', '/calculadora-intro'].includes(this._route.url)) {
      backgroundColor = '#E9EDF5';
    }

    document.body.style.backgroundColor = backgroundColor;
  }

}

// export function Required(target: object, propertyKey: string): void {
//   const getter = () => {
//     throw new Error(`Attribute ${propertyKey} is required`);
//   };
//
//   const setter = (value: any) => {
//     Object.defineProperty(target, propertyKey, {
//       value,
//       writable: true,
//       configurable: true,
//     });
//   };
//
//   Object.defineProperty(target, propertyKey, {
//     get: getter,
//     set: setter,
//   });
// }
